// Assessment schema — LEAN 16-question flow.
// Structured around 5 core cosmetic pillars:
//   1. Scalp condition   2. Strand thickness   3. Density
//   4. Damage & porosity 5. Main goal
// (+ basic profile + heat/environment context)
//
// All quiz answer photos are admin-editable via /admin/images.
// Defaults below are curated Pinterest-style stock (Unsplash open license).

const IMG = {
  // People / generic
  woman:            "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  man:              "https://images.unsplash.com/photo-1523251343397-9225e4cb6319?w=800&q=80",

  // Texture — matched to each hair pattern
  hair_straight:    "https://images.unsplash.com/photo-1512310604669-443f26c35f52?w=800&q=80",
  hair_wavy:        "https://images.unsplash.com/photo-1522336572468-97b06e8ef143?w=800&q=80",
  hair_curly:       "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=800&q=80",
  hair_coily:       "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=800&q=80",

  // Length — from short to very long
  short:            "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=800&q=80",
  medium_len:       "https://images.unsplash.com/photo-1522336572468-97b06e8ef143?w=800&q=80",
  long:             "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&q=80",
  very_long:        "https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=800&q=80",

  // Strand thickness — fine wispy vs medium vs coarse (thick voluminous)
  fine:             "https://images.unsplash.com/photo-1521252659862-eec69941b071?w=800&q=80",
  medium_strand:    "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  coarse:           "https://images.unsplash.com/photo-1508216310976-c518daae0cdc?w=800&q=80",

  // Density
  density_low:      "https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=800&q=80",
  density_med:      "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  density_high:     "https://images.unsplash.com/photo-1595351298020-038700609878?w=800&q=80",

  // Scalp condition
  scalp_balanced:   "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80",
  scalp_oily:       "https://images.unsplash.com/photo-1526045478516-99145907023c?w=800&q=80",
  scalp_dry:        "https://images.unsplash.com/photo-1550831107-1553da8c8464?w=800&q=80",
  scalp_sensitive:  "https://images.unsplash.com/photo-1526045478516-99145907023c?w=800&q=80",
  scalp_itchy:      "https://images.unsplash.com/photo-1600180758890-6b94519a8ba6?w=800&q=80",
  scalp_flaky:      "https://images.unsplash.com/photo-1600180758890-6b94519a8ba6?w=800&q=80",

  // Damage & porosity
  damage_healthy:   "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=800&q=80",
  damage_slight:    "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&q=80",
  damage_porous:    "https://images.unsplash.com/photo-1516575150278-77136aed6920?w=800&q=80",

  // Chemistry
  chem_none:        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  chem_color:       "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=800&q=80",
  chem_bleach:      "https://images.unsplash.com/photo-1516575150278-77136aed6920?w=800&q=80",
  chem_straight:    "https://images.unsplash.com/photo-1512310604669-443f26c35f52?w=800&q=80",

  // Wash + heat tools + heat shield + env
  shampoo:          "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=800&q=80",
  tools:            "https://images.unsplash.com/photo-1571875257727-256c39da42af?w=800&q=80",
  shield:           "https://images.unsplash.com/photo-1550505095-81378a674395?w=800&q=80",
  sun:              "https://images.unsplash.com/photo-1523206489230-c012c64b2b48?w=800&q=80",
  pool:             "https://images.unsplash.com/photo-1519669556878-63bdad8a1a49?w=800&q=80",
  water:            "https://images.unsplash.com/photo-1550505095-81378a674395?w=800&q=80",

  // Goals — semantic matching per concern
  goal_fall:        "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=800&q=80",
  goal_breakage:    "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=800&q=80",
  goal_volume:      "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=800&q=80",
  goal_frizz:       "https://images.unsplash.com/photo-1521252659862-eec69941b071?w=800&q=80",
  goal_dryness:     "https://images.unsplash.com/photo-1550831107-1553da8c8464?w=800&q=80",
  goal_dullness:    "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
  goal_color:       "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?w=800&q=80",

  // Life stage
  pregnant:         "https://images.unsplash.com/photo-1541516160071-4bb0c5af65ba?w=800&q=80",
  breastfeeding:    "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=800&q=80",
  none_life:        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&q=80",
};

const O = (id, en, it, image, scoring = {}) => ({ id, label: { en, it }, image, scoring });

export const GENDER_QUESTION = {
  id: "gender_for_visual",
  title: { en: "Who is this assessment for?", it: "Per chi è questa analisi?" },
  helper: { en: "First things first — let's tailor this to you.", it: "Prima cosa: adattiamo tutto a te." },
  options: [
    O("woman", "Woman", "Donna", IMG.woman),
    O("man", "Man", "Uomo", IMG.man),
  ],
};

export const AGE_QUESTION = {
  id: "age_band",
  title: { en: "What is your age?", it: "Qual è la tua età?" },
  helper: {
    en: "Hair needs shift with every decade — this puts you on the right track from question one.",
    it: "Le esigenze dei capelli cambiano con ogni decennio — questa domanda ci mette subito nella giusta direzione.",
  },
  options: [
    O("under_18", "Under 18", "Meno di 18 anni", IMG.woman),
    O("18_34", "18 – 34", "18 – 34", IMG.woman),
    O("35_54", "35 – 54", "35 – 54", IMG.woman),
    O("55_plus", "55 +", "55 +", IMG.woman),
  ],
};

export const LIFE_STAGE_QUESTION = {
  id: "life_stage",
  title: {
    en: "Are you currently pregnant or breastfeeding?",
    it: "Sei attualmente in gravidanza o in allattamento?",
  },
  helper: {
    en: "You're caring for two right now — your routine should too.",
    it: "In questo momento ti prendi cura di due — anche la tua routine dovrebbe farlo.",
  },
  options: [
    O("pregnant", "Pregnant", "In gravidanza", IMG.pregnant),
    O("breastfeeding", "Breastfeeding", "In allattamento", IMG.breastfeeding),
    O("none", "None of the above", "Nessuna delle precedenti", IMG.none_life),
  ],
};

export const PHASES = [
  {
    id: "profile",
    title: { en: "About your hair", it: "I tuoi capelli" },
    insight: {
      title: { en: "Same curl, different needs.", it: "Stesso ricciolo, esigenze diverse." },
      body: {
        en: "It's porosity, not pattern, calling the shots here. Let's find yours.",
        it: "È la porosità, non il ricciolo, a comandare. Troviamo la tua.",
      },
    },
    questions: [
      { id: "texture", title: { en: "Which best describes your hair texture?", it: "Quale descrive meglio la texture dei tuoi capelli?" }, helper: { en: "Your natural pattern is the base note everything else is built on.", it: "Il tuo pattern naturale è la nota base su cui costruiamo tutto il resto." }, options: [
        O("straight", "Straight", "Liscia", IMG.hair_straight),
        O("wavy", "Wavy", "Ondulata", IMG.hair_wavy, { hydration_need: 1 }),
        O("curly", "Curly", "Riccia", IMG.hair_curly, { hydration_need: 2, protection_need: 1 }),
        O("coily", "Coily", "Afro", IMG.hair_coily, { hydration_need: 3, protection_need: 2 }),
      ]},
      { id: "length", title: { en: "How long is your hair right now?", it: "Attualmente, quanto sono lunghi i tuoi capelli?" }, helper: { en: "Longer hair carries more history — and history needs a routine that respects it.", it: "Capelli più lunghi portano più storia — e la storia merita una routine che la rispetti." }, options: [
        O("short", "Short", "Corti", IMG.short),
        O("medium", "Medium", "Medi", IMG.medium_len, { structural_damage: 1 }),
        O("long", "Long", "Lunghi", IMG.long, { structural_damage: 2, hydration_need: 1 }),
        O("very_long", "Very long", "Molto lunghi", IMG.very_long, { structural_damage: 3, hydration_need: 2 }),
      ]},
      { id: "thickness", title: { en: "How thick is a single hair strand?", it: "Quanto è spesso un singolo capello?" }, helper: { en: "Roll one strand between your fingers — that tells us exactly how much product your hair can actually hold.", it: "Fai rotolare un capello tra le dita — ci dice esattamente quanto prodotto i tuoi capelli riescono davvero a trattenere." }, options: [
        O("fine", "Fine", "Fine", IMG.fine, { structural_damage: 1, shedding_concern: 1 }),
        O("medium_t", "Medium", "Medio", IMG.medium_strand),
        O("coarse", "Coarse", "Grosso", IMG.coarse, { buildup_tendency: 1 }),
      ]},
    ],
  },
  {
    id: "scalp",
    title: { en: "Scalp condition", it: "Condizione del cuoio" },
    insight: {
      title: { en: "Your scalp talks before your ends do.", it: "Il cuoio parla prima delle punte." },
      body: {
        en: "Oil moves differently through every hair type. You're in good company either way.",
        it: "Il sebo si muove diversamente per ogni tipo di capello. Sei in buona compagnia in ogni caso.",
      },
    },
    questions: [
      { id: "scalp_feel", title: { en: "What is your scalp condition?", it: "Qual è la condizione del tuo cuoio capelluto?" }, helper: { en: "Every great routine actually starts here, not at the ends.", it: "Ogni grande routine parte davvero da qui, non dalle punte." }, options: [
        O("balanced", "Balanced", "Equilibrato", IMG.scalp_balanced),
        O("oily", "Oily", "Grasso", IMG.scalp_oily, { scalp_balance: 3, buildup_tendency: 2 }),
        O("dry", "Dry", "Secco", IMG.scalp_dry, { scalp_balance: 2, hydration_need: 2 }),
        O("sensitive", "Sensitive", "Sensibile", IMG.scalp_sensitive, { scalp_balance: 2, protection_need: 1 }),
        O("itchy", "Itchy", "Con prurito", IMG.scalp_itchy, { scalp_balance: 3, protection_need: 1 }),
        O("flaky", "Flaky", "Con desquamazione", IMG.scalp_flaky, { scalp_balance: 3, buildup_tendency: 2 }),
      ]},
      { id: "wash_freq", title: { en: "How often do you wash your hair?", it: "Ogni quanto lavi i capelli?" }, helper: { en: "There's no \"correct\" number — just the rhythm that's honestly yours.", it: "Non c'è un numero \"giusto\" — solo il ritmo che è davvero tuo." }, options: [
        O("daily", "Every day", "Tutti i giorni", IMG.shampoo, { scalp_balance: 2, buildup_tendency: 1, structural_damage: 1 }),
        O("alt", "Every other day", "A giorni alterni", IMG.shampoo, { scalp_balance: 1 }),
        O("2_3", "2 – 3 × per week", "2 – 3 volte / sett.", IMG.shampoo),
        O("weekly", "Once a week or less", "Una volta a sett. o meno", IMG.shampoo, { buildup_tendency: 2 }),
      ]},
    ],
  },
  {
    id: "density",
    title: { en: "Hair density", it: "Densità dei capelli" },
    insight: {
      title: { en: "Density moves with the seasons.", it: "La densità cambia con le stagioni." },
      body: {
        en: "It moves with stress and hormones too. Today's snapshot is all we need to build from.",
        it: "Cambia anche con stress e ormoni. La foto di oggi ci basta per iniziare.",
      },
    },
    questions: [
      { id: "density", title: { en: "How dense is your hair overall?", it: "Quanto sono densi i tuoi capelli nel complesso?" }, helper: { en: "A quick look in the mirror — scalp barely visible means high, easily visible means low. Either way, it's a number we can work with, not a verdict.", it: "Uno sguardo veloce allo specchio — cuoio quasi invisibile = alta, ben visibile = bassa. In ogni caso è un dato con cui lavorare, non un verdetto." }, options: [
        O("low_d", "Low", "Bassa", IMG.density_low, { shedding_concern: 2 }),
        O("medium_d", "Medium", "Media", IMG.density_med),
        O("high_d", "High", "Alta", IMG.density_high),
      ]},
    ],
  },
  {
    id: "damage",
    title: { en: "Damage & porosity", it: "Danno & porosità" },
    insight: {
      title: { en: "How hair breaks says more than how it grows.", it: "Come si spezza dice più di come cresce." },
      body: {
        en: "Porosity is just the door moisture walks through — let's read yours.",
        it: "La porosità è solo la porta da cui passa l'idratazione — leggiamo la tua.",
      },
    },
    questions: [
      { id: "damage_level", title: { en: "How would you describe your hair's condition?", it: "Come descriveresti la condizione dei tuoi capelli?" }, helper: { en: "Be honest here — this is the one question that saves your hair the most trouble later.", it: "Sii sincera qui — questa è la domanda che risparmierà più problemi ai tuoi capelli in futuro." }, options: [
        O("healthy", "Healthy", "Sana", IMG.damage_healthy),
        O("slight", "Slightly damaged", "Leggermente danneggiata", IMG.damage_slight, { structural_damage: 2, reconstruction_need: 1, hydration_need: 1 }),
        O("highly_porous", "Highly porous / bleached", "Molto porosa / decolorata", IMG.damage_porous, { structural_damage: 3, reconstruction_need: 3, hydration_need: 2, protection_need: 1 }),
      ]},
      { id: "chem", title: { en: "Chemical services in the last year?", it: "Trattamenti chimici nell'ultimo anno?" }, helper: { en: "Every treatment leaves a signature on your hair — we're reading it, not judging it.", it: "Ogni trattamento lascia una firma sui capelli — noi la leggiamo, non la giudichiamo." }, options: [
        O("none_chem", "None", "Nessuno", IMG.chem_none),
        O("color", "Colouring", "Colore", IMG.chem_color, { structural_damage: 2, reconstruction_need: 1, protection_need: 1 }),
        O("bleach", "Bleach or lightening", "Decolorazione o schiaritura", IMG.chem_bleach, { structural_damage: 3, reconstruction_need: 3, protection_need: 2 }),
        O("chem_treatment", "Straightening / perm", "Stiratura / permanente", IMG.chem_straight, { structural_damage: 3, reconstruction_need: 3 }),
      ]},
    ],
  },
  {
    id: "heat_env",
    title: { en: "Heat & environment", it: "Calore & ambiente" },
    insight: {
      title: { en: "Heat isn't the enemy — unprotected heat is.", it: "Il calore non è il nemico — lo è il calore senza protezione." },
      body: {
        en: "A small shield goes a long way.",
        it: "Un piccolo scudo fa un'enorme differenza.",
      },
    },
    questions: [
      { id: "heat_freq", title: { en: "How often do you use heat tools (blow-dry or flat iron)?", it: "Ogni quanto usi il calore (phon o piastra)?" }, helper: { en: "However often you reach for it, we'll make sure it's working with you, not against you.", it: "Qualunque sia la frequenza, ci assicureremo che il calore lavori con te, non contro di te." }, options: [
        O("rarely_hf", "Rarely / never", "Raramente / mai", IMG.tools),
        O("weekly_hf", "Weekly", "Settimanale", IMG.tools, { heat_exposure: 2, protection_need: 2 }),
        O("daily_hf", "Daily", "Ogni giorno", IMG.tools, { heat_exposure: 3, protection_need: 3, structural_damage: 2 }),
      ]},
      { id: "heat_shield", title: { en: "Do you use a heat-protection product?", it: "Usi un prodotto di protezione dal calore?" }, helper: { en: "This one small habit quietly changes almost everything else on this list.", it: "Questa piccola abitudine cambia in silenzio quasi tutto il resto della lista." }, options: [
        O("always_h", "Always", "Sempre", IMG.shield),
        O("sometimes_h", "Sometimes", "A volte", IMG.shield, { protection_need: 2 }),
        O("never_h", "Never", "Mai", IMG.shield, { protection_need: 3, heat_exposure: 1 }),
      ]},
      { id: "outdoor_exposure", title: { en: "How much sun / pool / sea does your hair get?", it: "Quanto sole / piscina / mare prendono i tuoi capelli?" }, helper: { en: "Chlorine, salt and sun are rewriting your porosity even when you can't see it happening.", it: "Cloro, sale e sole stanno riscrivendo la tua porosità anche quando non te ne accorgi." }, options: [
        O("low_e", "Low", "Basso", IMG.woman),
        O("mid_e", "Occasional sun or swim", "Sole o nuoto occasionali", IMG.sun, { protection_need: 2, hydration_need: 1, structural_damage: 1 }),
        O("high_e", "Frequent beach or pool", "Spiaggia o piscina frequenti", IMG.pool, { protection_need: 3, hydration_need: 2, structural_damage: 2 }),
      ]},
    ],
  },
  {
    id: "goal",
    title: { en: "Your main goal", it: "Il tuo obiettivo" },
    insight: {
      title: { en: "One thing beautifully — not everything at once.", it: "Una cosa alla perfezione — non tutto insieme." },
      body: {
        en: "The right routine solves one thing beautifully. Choose the change you'd notice first.",
        it: "La routine giusta risolve una cosa in modo perfetto. Scegli il cambiamento che noteresti per primo.",
      },
    },
    questions: [
      { id: "current_routine", title: { en: "What's your current haircare routine?", it: "Qual è la tua routine attuale?" }, helper: { en: "No judgment at all — just today's starting point, whatever it is.", it: "Nessun giudizio — solo il punto di partenza di oggi, qualunque sia." }, options: [
        O("only_shampoo", "Only shampoo", "Solo shampoo", IMG.shampoo, { buildup_tendency: 1, protection_need: 1 }),
        O("sh_conditioner", "Shampoo + conditioner", "Shampoo + balsamo", IMG.shampoo),
        O("sh_cond_mask", "Shampoo + conditioner + mask", "Shampoo + balsamo + maschera", IMG.shampoo),
        O("full_routine", "Full routine (+ treatment / serum)", "Routine completa (+ trattamento / siero)", IMG.shampoo),
      ]},
      { id: "main_goal", title: { en: "What is your main concern and goal?", it: "Qual è la tua principale preoccupazione e obiettivo?" }, helper: { en: "Pick the one change you'd notice first — that's exactly where we'll start.", it: "Scegli il cambiamento che noteresti per primo — è esattamente da lì che partiremo." }, options: [
        O("hair_fall", "Hair fall", "Caduta dei capelli", IMG.goal_fall, { shedding_concern: 3 }),
        O("breakage", "Breakage", "Rottura", IMG.goal_breakage, { reconstruction_need: 2, structural_damage: 2 }),
        O("volume", "Lack of volume", "Mancanza di volume", IMG.goal_volume, { shedding_concern: 2 }),
        O("frizz", "Frizz", "Effetto crespo", IMG.goal_frizz, { hydration_need: 2, protection_need: 1 }),
        O("dryness", "Dryness", "Secchezza", IMG.goal_dryness, { hydration_need: 3 }),
        O("dullness", "Dullness", "Opacità", IMG.goal_dullness, { hydration_need: 2, buildup_tendency: 1 }),
        O("colored_maintain", "Maintain coloured hair", "Mantenere il colore", IMG.goal_color, { protection_need: 2, hydration_need: 1 }),
      ]},
    ],
  },
];
